// Bundle único de front para TUDO que roda no site
import './blocks/carousel/front';
import './blocks/image-accordion/front';

// Extensão
// core/image (FRONT CSS)
import './extensions/extend-core-image-focal/extend-core-image-focal.scss';